import { Clerk } from '@clerk/clerk-js/headless';
import { GraphQLClient } from 'graphql-request';

import { getGraphqlEndpointByService } from 'utils/api.utils';
import { hasWindow } from 'utils/browser.utils';

import { ApiSubDomainLookup } from 'constants/api.constants';

const clerk = new Clerk(process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY!);

const getAuthToken = async () => {
  if (!hasWindow()) return null;
  if (!clerk.loaded) await clerk.load({ telemetry: false });
  return await clerk.session?.getToken();
};

export const createAuthenticatedFetcher: typeof fetch = async (input, init) => {
  const sessionToken = await getAuthToken();

  return fetch(input, {
    headers: {
      ...init?.headers,
      Authorization: !!sessionToken
        ? `Bearer ${sessionToken}`
        : `ApiKey ${process.env.NEXT_PUBLIC_API_KEY}`,
    },
    body: init?.body,
    method: init?.method,
  });
};

export const buildAwsRequester = (service: keyof typeof ApiSubDomainLookup) => {
  const url = getGraphqlEndpointByService(service);

  return new GraphQLClient(url, {
    fetch: createAuthenticatedFetcher,
  });
};
